import { render, staticRenderFns } from "./mobile_bottom_nav.vue?vue&type=template&id=858eaf0a&scoped=true&"
import script from "./mobile_bottom_nav.vue?vue&type=script&lang=js&"
export * from "./mobile_bottom_nav.vue?vue&type=script&lang=js&"
import style0 from "./mobile_bottom_nav.vue?vue&type=style&index=0&id=858eaf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858eaf0a",
  null
  
)

export default component.exports